import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ensureWebPushRegistered } from './push/webPush';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

function dismissBootSplash() {
  const splash = document.getElementById('boot-splash');
  if (!splash) return;
  const started = Number(splash.dataset.started) || Date.now();
  const wait = Math.max(0, 700 - (Date.now() - started));
  window.setTimeout(() => {
    splash.classList.add('is-done');
    window.setTimeout(() => splash.remove(), 300);
  }, wait);
}

dismissBootSplash();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    const data = event.data;
    if (!data || data.type !== 'NOTIFICATION_CLICK') return;
    // PushToastListener (inside Router) also handles navigation when mounted.
    const path =
      typeof data.path === 'string'
        ? data.path
        : typeof data.url === 'string'
          ? data.url
          : '/alerts';

    if (data.external || /^https?:\/\//i.test(path)) {
      window.open(
        typeof data.url === 'string' ? data.url : path,
        '_blank',
        'noopener,noreferrer',
      );
      return;
    }

    const next =
      path.startsWith('/')
        ? path
        : typeof data.url === 'string'
          ? new URL(data.url).pathname + new URL(data.url).search
          : '/alerts';
    if (window.location.pathname + window.location.search !== next) {
      window.location.assign(next);
    }
  });
}

serviceWorkerRegistration.register({
  onSuccess: () => {
    void ensureWebPushRegistered();
  },
  onUpdate: () => {
    void ensureWebPushRegistered();
  },
});

void ensureWebPushRegistered();
